<template>
  <div id="control-panel">
    <div id="fixed-controls">
      <h3>{{ $t("Graph") }}</h3>
      <div class="Box">
        <input type="checkbox" :disabled="this.$store.getters.disciplines_seleccionades.length!=0" :style="this.$store.getters.disciplines_seleccionades.length!=0 ? 'cursor: default;' : 'cursor: pointer;' " v-model="heat_map" @change="update_heat_map"/>
        <label v-if="this.$store.getters.disciplines_seleccionades.length!=0" style="text-decoration: line-through; ">{{ $t("Growth Map") }}</label>
        <label v-else style="text-decoration: none;">{{ $t("Growth Map") }}</label>
      </div>
      <div class="Box">
        <input type="checkbox" style="cursor: pointer;" v-model="hide_nodes" @change="update_hide_nodes"/>
        <label>{{ $t("Hide nodes") }}</label>
      </div>

      <div class="Box">

        <input type="checkbox" style="cursor: pointer;" v-model="hide_arestes" @change="update_hide_arestes"/>
        <label>{{ $t("Hide edges") }}</label>
      </div>
      <h3>{{ $t("Years") }}</h3>

      <div class="Box"> 
        <vue-range-slider class= "slider" :min="parseInt(this.$store.getters.any_actual[0])" :max="parseInt(this.$store.getters.any_actual[1])" :enable-cross="false"
        v-model="anys_slider" v-on:slide-end="canviRang" :processDraggable="true" :clickable="false" />
      </div>
      <!--
      <h3>Edges</h3>
      <div class="Box">
        <vue-range-slider class= "slider" :min="0" :max="1.0" :step="0.2" :enable-cross="false" 
        v-model="opacitat_arestes" v-on:slide-end="canviOpacitat" ></vue-range-slider>
      </div>
      -->
      <h3>{{ $t("Clusters") }}</h3>
    </div>
    <div id="clust-wrapper">
      <vue-custom-scrollbar class="scroll-area-clusters" :settings="scroll_settings">
        <div v-for="(clust, index) in this.llista_clusters_store" v-bind:key="clust['id']">
          <input
            v-model="$store.state.clusters_seleccionats" 
            :id="clust['id']"
            checked
            type="checkbox"
            :value="clust['id']"
            style="cursor: pointer;display: inline-block;"
            @change="updateClustersMarcats"
          />

          <label
            :for="clust['id']"
            class="unselectable"
            style="display: block; margin-left: 0.3em; margin-top: -23px; cursor: pointer; overflow-x: hidden; text-overflow: ellipsis;"
          >
            <div
              :style="{
                display: 'inline-block',
                margin: '0px 0px 0px 0px',
                width: '0.9em',
                height: '0.9em',
              }"
            ></div>
            {{index+1}} 
            <div style="width: 0.75em; display: inline-block; height: 0.75em; border: 1px solid gray;" v-bind:style="{ 'background-color': colorCluster(index) }"></div>
            {{ clust['cluster'] === 'undefined' ? $t('Non-clustered') : clust['cluster'] }}
          </label>
        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>
<script>
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"

export default {
  components: {
    VueRangeSlider,
    vueCustomScrollbar,
  },
  name: "Filtres",
  props: ["api_url"],
  data() {
    return {
      anys_slider: [2010,2020],
      opacitat_arestes: 0.25,
      arestagris: false,
      heat_map: false,
      hide_nodes: false,
      hide_arestes: false,
      scroll_settings: {
        supressScrollX: true,
        minScrollbarLength: 50,
        maxScrollbarLength: 250,
        scrollXMarginOffset: 1000
      }
    };
  },
  beforeCreate() {
    this.anys_slider = [parseInt(this.$store.getters.any_actual[0]), parseInt(this.$store.getters.any_actual[1])];
  },
  created() {
    VueRangeSlider.methods.handleKeyup = ()=> {};
    VueRangeSlider.methods.handleKeydown = ()=> {};
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'reset') {
        this.heat_map = false;
        this.hide_nodes = false;
        this.hide_arestes = false;
      }
    });
  },
  methods: {
    colorCluster: function (index){
      return this.$store.getters.clusters[index].color
    },

    arestesgrises: function (){
      this.$store.dispatch("ArestesGrises", this.arestagris);
    },
    updateClustersMarcats: function () {
      this.$store.dispatch("MarcarClusters", this.$store.getters.clusters_seleccionats);
      if (this.$store.getters.display_cluster) { this.$root.$emit("ActualitzaInfoCluster"); }
      else { this.$root.$emit('ClusterInfoActualitzat'); }
    },
    update_hide_arestes: function(){
      if(this.hide_arestes)
        this.$store.dispatch("CanviOpacitat",0);
      else
        this.$store.dispatch("CanviOpacitat",this.opacitat_arestes);
    },
    update_heat_map: function(){
        this.$store.dispatch("PintarHeatMap", this.heat_map)
    },
    canviRang: function () {
      this.$store.dispatch("AnysSeleccionats", this.anys_slider);
    },
  
    resetFiltres: function() {
    },
    canviOpacitat : function() {
      this.$store.dispatch("CanviOpacitat", this.opacitat_arestes);
    },
    update_hide_nodes: function(){
      this.$store.dispatch("HideNodes", this.hide_nodes);
    }

    
  },

  computed: {
    llista_clusters_store() {
      return this.$store.getters.clusters;
    },
   
  },
};
</script>
<style>
#control-panel {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: max-content auto;
  overflow: hidden;
  position: relative;
  line-height: 1.6;
  background: #fff;
}
#control-panel h3 {
  margin: 0;
  padding: 5px 0;
  line-height: 1.6;
}
#fixed-controls {
  margin: 0 10px;
  border-bottom: 1px solid #AAA;
}

.Box {
  margin-right: 0.5em;
}

#clust-wrapper {
  width: 100%;
  height: calc(100% - 5px);
  overflow-x: hidden;
  margin-top: 5px;
}
.scroll-area-clusters {
  margin: 0 0 0 5px;
  padding: 0 15px 0 0;
  height: inherit;
  overflow-x: hidden;
}

.slider{
    margin-top: 1.5em;
    margin-right: 1em;
    margin-left: 1em;
}
</style>
